import {createAction, createSelector} from '@reduxjs/toolkit'

export const actions = {
  enter: createAction('enter', (id, info) => ({payload: {id, info}})),
  exit: createAction('exit', id => ({payload: {id}})),
}

const initialState = {
  infos: {}, // [id]: {sortKey, dividerAbove, dividerBelow, ...etc}
}

const createRootReducer =
  () =>
  (state = initialState, action) => {
    switch (action.type) {
      case actions.enter.type: {
        const {id, info} = action.payload
        return {
          ...state,
          infos: {
            ...state.infos,
            [id]: {
              dividerAbove: true,
              dividerBelow: true,
              ...state.infos[id],
              ...info,
            },
          },
        }
      }
      case actions.exit.type: {
        const {id} = action.payload
        const infos = {...state.infos}
        delete infos[id]
        return {
          ...state,
          infos,
        }
      }
      default:
        return state
    }
  }

const getInfos = state => state.infos

const getPrevInfos = createSelector([getInfos], infos => {
  let prev
  return Object.entries(infos)
    .sort(([, {sortKey: a}], [, {sortKey: b}]) =>
      a === b ? 0 : a < b ? -1 : 1,
    )
    .reduce((prevInfos, [k, info]) => {
      prevInfos[k] = prev
      prev = info
      return prevInfos
    }, {})
})

export const selectors = {
  getInfos,
  getPrevInfos,
}

export default createRootReducer
